import { newUpgrade } from '@ff-os/shared-utils/upgrades/newUpgrade';
import { Upgrade } from '@ff-os/shared-utils/upgrades/upgrades';
import { replaceAzureUrlsWithIdtUrls } from './scripts/2022-10-11-replace-azure-urls-width-idt-urls/2022-10-11-replace-azure-urls-width-idt-urls';
import { ensureEntityIdsAreSet } from './scripts/2022-11-17-ensure-entity-ids-are-set/2022-11-17-ensure-entity-ids-are-set';
import { addActiveVariantIdToMeta } from './scripts/2022-11-18-add-active-variant-id-to-meta/2022-11-18-add-active-variant-id-to-meta';
import { reduceProjectContent } from './scripts/2022-11-24-reduce-project-content/2022-11-24-reduce-project-content';
import { replaceAssetUrlInPhoto } from './scripts/2022-12-27-replace-asset-url-in-photo/2022-12-27-replace-asset-url-in-photo';

export const giftUpgrades: Upgrade[] = [
    newUpgrade('idt-urls', replaceAzureUrlsWithIdtUrls),
    newUpgrade('entity-ids', ensureEntityIdsAreSet),
    newUpgrade('active-variant-id', addActiveVariantIdToMeta),
    newUpgrade('reduce-project-content', reduceProjectContent),
    newUpgrade('replace-asset-url-in-photo', replaceAssetUrlInPhoto)
];